import { Injectable } from "@angular/core";
//import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UTILITIES } from "./core/utility/utilities";
import { Storage } from "@ionic/storage";
import { InAppPurchase } from '@ionic-native/in-app-purchase/ngx';
import { HTTP } from '@ionic-native/http/ngx';
@Injectable({
  providedIn: "root"
})
export class InAppService {
  constructor(
    private utilities: UTILITIES,
    private storage: Storage,
    // private httpClient: HttpClient,
    private iap: InAppPurchase,
    private http: HTTP

  ) { }


  // Don't call this every app open, it requires iTunes login.
  checkStatus(userId) {
    // nested promises
    return new Promise((resolve, reject) => {
      // first, ask Apple for the receipt. We get back an encrypted string.
      this.iap.getReceipt()
        .then(receipt => {
          return receipt
        })
        .then(receiptData => {
          //    console.log('encoded', receiptData)
          // next, validate the encoded receipt with Apple, and get back the human readable format;
          this.validateReceipt(receiptData,userId, null, null).then(receipt => {
            console.log('validate receipt response', receipt);
            resolve(receipt);
          }).catch(err => {
            console.log("Validate Receipt Error")
            reject(err);
          })
        })
        .catch(err => {
          console.log("Read Receipt Error")
          reject(err);
        })

    })

  }

  validateReceipt(receiptData, userId, period, expDate) {
    return new Promise((resolve, reject) => {
      let data = {
        'receipt': receiptData,
        'userId': userId,
        'period' : period,
        "expDate": expDate
      }
      this.http.post('https://us-central1-fightitaway-285807.cloudfunctions.net/validateReceipts', data, {})
        .then(data => {
          resolve(JSON.parse(data.data));
        })
        .catch(error => {
          console.log("validateReceipts Error", error.error); // error message as string
          reject(error.error);
        });


    })

  }

  validateGoogleReceipt(receiptData, userId) {
    return new Promise((resolve, reject) => {
      let data = {
        'receipt': receiptData,
        'userId': userId
      }
      this.http.post('https://us-central1-fightitaway-285807.cloudfunctions.net/validateGoogleReceipts', data, {})
        .then(data => {
          resolve(JSON.parse(data.data));
        })
        .catch(error => {
          console.log("validateReceipts Error", error.error); // error message as string
          reject(error.error);
        });


    })

  }
}
